<template>
  <div class="welcome-page-discover">
    <h3 class="welcome-page-discover__title">
      {{ $t('welcomePage.discover.skinThickness.title') }}
    </h3>
    <p class="welcome-page-discover__paragraph">
      {{ $t('welcomePage.discover.skinThickness.p1') }}
      <br />
      {{ $t('welcomePage.discover.skinThickness.p2') }}
    </p>

    <p class="welcome-page-discover__paragraph">
      {{ $t('welcomePage.discover.skinThickness.articleDescription') }}
    </p>
    <p class="welcome-page-discover__paragraph">
      {{ $t('welcomePage.discover.skinThickness.articleSummary') }}
    </p>
    <p class="welcome-page-discover__paragraph pre-line">
      {{ $t('welcomePage.discover.skinThickness.p3') }}
    </p>
    <p class="welcome-page-discover__paragraph">
      {{ $t('welcomePage.discover.skinThickness.p4') }}
      <br />
      {{ $t('welcomePage.discover.skinThickness.p5') }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'SkinThicknessDiscover'
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/welcome-page-discover.scss';
</style>
